"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunningCalculateMetadata = exports.loaderLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const colors_1 = require("../helpers/colors");
const styles_1 = require("./Menu/styles");
const Spinner_1 = require("./Spinner");
const layout_1 = require("./layout");
exports.loaderLabel = {
    fontSize: 14,
    color: colors_1.LIGHT_TEXT,
    fontFamily: 'sans-serif',
    lineHeight: 1.5,
};
const container = {
    backgroundColor: colors_1.BACKGROUND,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 20,
};
const RunningCalculateMetadata = () => {
    return ((0, jsx_runtime_1.jsxs)("div", { style: container, children: [(0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { size: 24, duration: 1 }), (0, jsx_runtime_1.jsx)(layout_1.Spacing, { x: 2 }), (0, jsx_runtime_1.jsxs)("div", { style: exports.loaderLabel, children: ["Running ", (0, jsx_runtime_1.jsx)("code", { style: styles_1.inlineCodeSnippet, children: "calculateMetadata()" }), "..."] })] }));
};
exports.RunningCalculateMetadata = RunningCalculateMetadata;
